export default class Product {
  constructor(name, price, extraCharge, treatmentType, slug, isShipped, id, planId) {
    this.name = name;
    this.price = price;
    this.extraCharge = extraCharge;
    this.treatmentType = treatmentType;
    this.slug = slug;
    this.isShipped = isShipped;
    this.id = id;
    this.planId = planId;
  }
}
